import React from 'react';
import { Link, useLocation } from 'react-router-dom';

// Sticky bottom strip: subtle live indicator + apply CTA. Hidden on /apply pages.
const StickyApplyBar = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith('/apply')) return null;
  return (
    <div
      data-testid="sticky-apply-bar"
      className="fixed bottom-3 left-1/2 -translate-x-1/2 z-40 px-3 w-auto max-w-[95vw]"
    >
      <Link
        to="/apply"
        className="group flex items-center gap-3 bg-dark-green text-cream pl-4 pr-1.5 py-1.5 rounded-full border border-cream/15 shadow-2xl backdrop-blur-md hover:border-cream/30 transition-colors duration-300"
      >
        <span className="relative flex h-2 w-2 flex-shrink-0">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-cream/70 opacity-75" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-cream" />
        </span>
        <span className="flex items-center gap-1.5 bg-cream text-dark-green text-sm font-medium px-4 py-1.5 sm:py-2 rounded-full group-hover:bg-cream/90 transition-colors">
          Apply
          <span aria-hidden className="group-hover:translate-x-0.5 transition-transform">&rarr;</span>
        </span>
      </Link>
    </div>
  );
};

export default StickyApplyBar;
